import React from 'react';
import DojoMemberStatusSelector from './DojoMemberStatusSelector';
import PeerActivityDisclosure, { peerActivityDisclosureTargetId } from './PeerActivityDisclosure';
import { getDojoSectionStatusClass } from './dojoActivityStatus';
import { isCameraMediaActivity } from '../../services/cameraMediaFeed';

export function activityTypeSectionLabel(config) {
  if (config.label === 'Media') return 'Media';
  if (config.label === 'Activity') return 'Activities';
  return `${config.label}s`;
}

export default function DojoActivityTypeSection({
  type,
  config,
  members,
  selectedMember,
  onSelect,
  backendService,
  personalItems,
  renderPersonalActivity,
  renderPeerActivityDetail,
  renderActivityName,
  selectionScope,
  showMembers = true,
  selfStatusClass,
}) {
  const selectedPeer = !selectedMember.isSelf;
  const visibleItems = selectedPeer ? selectedMember.activities : personalItems;
  const statusClass = selectedPeer
    ? getDojoSectionStatusClass(selectedMember.status)
    : (selfStatusClass ?? getDojoSectionStatusClass(selectedMember.status));
  return (
    <div className={`todo-type-group open ${statusClass}`}>
      <div className="todo-type-header">
        <span className="todo-type-icon">{config.icon}</span>
        <span className="todo-type-label">{activityTypeSectionLabel(config)}</span>
      </div>
      <div className="todo-type-items">
        {showMembers && <div className="todo-type-member-status">
          <DojoMemberStatusSelector
            members={members}
            selectedId={selectedMember.id}
            label={config.label}
            onSelect={onSelect}
            workout={type === 'workout'}
          />
        </div>}
        {selectedPeer
          ? (visibleItems.length ? visibleItems.map(activity => isCameraMediaActivity(activity)
            ? <React.Fragment key={`${selectionScope}:${selectedMember.id}:${activity._id}`}>{renderPeerActivityDetail(activity)}</React.Fragment>
            : <PeerActivityDisclosure
              key={`${selectionScope}:${selectedMember.id}:${activity._id}:${peerActivityDisclosureTargetId(activity)}`}
              activity={activity}
              selectedMemberContext
              owner={selectedMember.user}
              backendService={backendService}
              renderActivityDetail={renderPeerActivityDetail}
              renderActivityName={renderActivityName}
            />) : <p className="nutrition-unknown">No {config.label.toLowerCase()} activity available for this day.</p>)
          : visibleItems.map(activity => renderPersonalActivity(activity, type))}
      </div>
    </div>
  );
}
